<template>
  <div id="comp-invite-group">
    <div class="add-item" @click="kakaoShare">
      <i class="fas fa-comment" style="color:#573839"></i>
      <span>{{ $t("friends.kakao") }}</span>
    </div>
    <div class="add-item" @click="$emit('urlAdd', getAddUrl)">
      <i class="fas fa-link"></i>
      <span>{{ $t("friends.urlAdd") }}</span>
    </div>
    <div class="add-item" @click="$emit('performMatch')">
      <i class="fas fa-qrcode" style="color:orange"></i>
      <span>{{ $t("friends.groupQr") }}</span>
    </div>
    <div class="add-item" @click="$emit('performQr')">
      <i class="fas fa-camera" style="color:#666"></i>
      <span>{{ $t("friends.qrScan") }}</span>
    </div>
    <div class="add-item" @click="$emit('myFriend')">
      <i class="fas fa-user" style="color:#666"></i>
      <span>{{ $t("match.myFriend") }}</span>
    </div>
  </div>
</template>

<script>
/* global Kakao */

import SOCIAL from '@/constants/social';

export default {
  name: 'comp-invite-group',
  props: {
    groupId: Number,
  },
  computed: {
    getAddUrl() {
      return process.env.ADD_GROUP_URI + this.groupId;
    },
  },
  methods: {
    kakaoShare() {
      if (typeof (Kakao.Link) === 'undefined') {
        this.initKakao();
      }

      const vm = this;
      const link = this.getAddUrl;

      this.$ga.event('AddGroup', 'KakaoLink', link);

      Kakao.Link.sendDefault({
        objectType: 'feed',
        content: {
          title: vm.$i18n.t('share.title'),
          description: vm.$i18n.t('share.addDesc'),
          imageUrl: vm.$i18n.t('share.imgUrl'),
          link: {
            mobileWebUrl: link,
            webUrl: link,
          },
        },
        installTalk: true,
        success(message) { // eslint-disable-line no-unused-vars
          vm.$emit('stopLoading');
        },
        fail(error) { // eslint-disable-line no-unused-vars
          vm.$emit('stopLoading');
        },
      });
    },
    initKakao() {
      Kakao.init(SOCIAL.KAKAO_CLIENT_ID);
    },
  },
};
</script>

<style lang="scss" src="../scss/comp-invite-group.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/CompInviteGroup.vue